import { memo } from 'react'

import BenefitList from '@/atoms/BenefitList'
import Product from '@/ts/Product'

import ExperienceDeadlines from '../ExperienceDeadlines'
import Header from './includes/Header'

function ExperienceCard({ product }: ExperienceCardProps) {
  return (
    <article className="flex justify-center flex-none px-6 py-8 border-2 shadow-xl xl:px-12 md:py-14 border-sbtviolet-100 rounded-xl">
      <div className="w-full max-w-md">
        <Header product={product} />
        <BenefitList benefits={product.benefits} color="yellow" />
        <ExperienceDeadlines product={product} />
      </div>
    </article>
  )
}

interface ExperienceCardProps {
  product: Product
}

export default memo(ExperienceCard)
